module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "id": "keep"
    }
  }, [_c('v-navigation-drawer', {
    staticClass: "grey lighten-4",
    attrs: {
      "app": "",
      "fixed": "",
      "clipped": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', {
    staticClass: "grey lighten-4 nav-drawer",
    attrs: {
      "dense": ""
    }
  }, [_vm._l((_vm.items), function(item, i) {
    return [(item.heading) ? _c('v-layout', {
      key: i,
      attrs: {
        "row": "",
        "align-center": ""
      }
    }) : (item.divider) ? _c('v-divider', {
      key: i,
      staticClass: "my-3",
      attrs: {
        "dark": ""
      }
    }) : _c('v-list-tile', {
      key: i,
      on: {
        "click": _vm.greet
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      staticClass: "grey--text"
    }, [_vm._v("\n              " + _vm._s(item.text) + "\n            ")])], 1)], 1)]
  })], 2)], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "child-flex": "",
      "wrap": "",
      "app": ""
    }
  }, [_c('div', [_c('v-toolbar', {
    staticClass: "amber brand"
  }, [_c('v-toolbar-title', [_c('router-link', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "to": "/",
      "tag": "span"
    }
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require("./assets/logo.png"),
      "alt": ""
    }
  })])])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-side-icon', {
    attrs: {
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.drawer = !_vm.drawer
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex-basis": "73%"
    }
  }, [_c('v-toolbar', {
    staticClass: "white"
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "Поиск",
      "prepend-icon": "search",
      "solo-inverted": "",
      "hide-details": ""
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "langselect"
  }, [_c('v-select', {
    attrs: {
      "items": _vm.dropdown_lang,
      "box": "",
      "placeholder": "УКР",
      "hide-details": ""
    }
  })], 1), _vm._v(" "), _c('div', [_c('v-btn', {
    attrs: {
      "flat": ""
    }
  }, [_vm._v("\n                Выйти\n                "), _c('v-icon', {
    staticClass: "ml-1"
  }, [_vm._v("exit_to_app")])], 1)], 1)], 1)], 1)])], 1), _vm._v(" "), _c('v-content', [_c('v-container', {
    staticClass: "grey lighten-4",
    attrs: {
      "fluid": "",
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "justify-center": "",
      "align-center": "",
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('v-card', [_c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_vm._l((_vm.list_items), function(item, index) {
    return [_c('v-list-tile', {
      key: item.title,
      attrs: {
        "avatar": "",
        "ripple": ""
      },
      on: {
        "click": function($event) {
          return _vm.toggle(index)
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('v-list-tile-sub-title', {
      staticClass: "text--primary"
    }, [_vm._v(_vm._s(item.headline))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(item.subtitle))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-list-tile-action-text', [_vm._v(_vm._s(item.action))]), _vm._v(" "), (_vm.selected.indexOf(index) < 0) ? _c('v-icon', {
      attrs: {
        "color": "grey lighten-1"
      }
    }, [_vm._v("\n                      star_border\n                    ")]) : _c('v-icon', {
      attrs: {
        "color": "yellow darken-2"
      }
    }, [_vm._v("\n                      star\n                    ")])], 1)], 1), _vm._v(" "), (index + 1 < _vm.list_items.length) ? _c('v-divider', {
      key: index
    }) : _vm._e()]
  })], 2)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-container', [_c('v-layout', {
    attrs: {
      "justify-end": "",
      "row": ""
    }
  }, [_c('div', [_c('v-pagination', {
    attrs: {
      "length": 5,
      "circle": ""
    },
    model: {
      value: (_vm.page),
      callback: function($$v) {
        _vm.page = $$v
      },
      expression: "page"
    }
  })], 1)])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53c6d8e7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 50
// module chunks = 1